import { render, staticRenderFns } from "./BrandListItem.vue?vue&type=template&id=42ec0e60&scoped=true&"
import script from "./BrandListItem.vue?vue&type=script&lang=js&"
export * from "./BrandListItem.vue?vue&type=script&lang=js&"
import style0 from "./BrandListItem.vue?vue&type=style&index=0&id=42ec0e60&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ec0e60",
  null
  
)

export default component.exports